import React from "react";
import Pic from "../assets/IMG_0540.JPG";

import {
  Text,
  Box,
  ImageBox,
  HeroBlurb,
  Section,
  PageContentWrapWithSideBar,
  Button,
  Page,
  Heading
} from "../theme";
import { PracticeAccordion } from "../Components/Accordian/Accordian";
import { Practices } from "../data";

export const Practice = props => {
  const {
    match: {
      params: { id }
    }
  } = props;
  const content = Practices[id];
  return (
    <Page>
      <ImageBox useFilter="true" width={1} bgImage={Pic}>
        <HeroBlurb heading="Taxation" image={Pic} color="secondaryLight" />
      </ImageBox>
      <PageContentWrapWithSideBar bg="secondaryLight" pb={5}>
        <Box width={2 / 3} pt={5} display="flex" alignItems="center">
          <PracticeAccordion />
        </Box>
      </PageContentWrapWithSideBar>
    </Page>
  );
};
export default Practice;
